import { useQuery } from '@tanstack/react-query';
import { useQuoteCreationFunctions } from '../../../../../accounts/accountUtils';
import { usePersona } from '../../../../../components/hooks/usePersona';
import {
  getAgencyAccountById,
  getAgencyDetails as getAgencyDetailsApi,
} from '../../../../../agencies/AgencyService';
import { useAPIErrorHandler } from '../../../../../components/hooks/useAPIErrorHandler';

export const useGetAgencyDetails = ({
  accountId,
}: {
  accountId: string | undefined;
}) => {
  const { getAgencyId } = useQuoteCreationFunctions();
  const persona = usePersona();
  const handleAPIError = useAPIErrorHandler();

  const getAgencyDetails = () => {
    if (persona.isAgency) {
      return getAgencyDetailsApi();
    }
    return getAgencyAccountById(getAgencyId());
  };

  return useQuery({
    queryKey: [['agency-details', accountId, persona.type]],
    queryFn: () => getAgencyDetails(),
    select: (response) => response.data,
    onError: handleAPIError(
      'Something went wrong while getting agency details'
    ),
    enabled: Boolean(accountId),
  });
};

export default useGetAgencyDetails;
